module.exports = __webpack_public_path__ + "img/Honigloeffel-v2-100.1208717d.png";